import React, { FormEvent, useCallback, useContext, useEffect, useMemo, useState } from "react";
import RegisterOscContext from "../../../context/RegisterContext";
import useApi from "../../../hooks/useApi";
import { SubmitButton } from "../../../Korbantech/components/Buttons/SubmitButton";
import { GridFields } from "../OscInputs/GridFields";
import { OscInput } from "../OscInputs/OscInput";
import { OscTrueFalseInput } from "../OscInputs/OscTrueFalseInput";
import { SuccessAlert } from '../../Alerts/SuccessAlert'
import { SpinnerLoad } from '../../Loading/SpinnerLoad'
import { Osc } from '../../../types/Osc';
import { MoneyInput } from "../OscInputs/MoneyInput";

export const StructOrganizationFields = ({oldData,update,isPublic}:Props) => {

    const { setStep } = useContext(RegisterOscContext)
    const { osc } = useContext(RegisterOscContext)

    const [newData, setNewData] = useState<Osc | undefined>(undefined)
    const [isSuccess, setIsSuccess] = useState<boolean>(false)
    const [load, setLoad] = useState<boolean>(false)

    const api = useApi();

    const handleSubmit = useCallback(async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        e.currentTarget.checkValidity()
        setLoad(true)
        if (!e.currentTarget) return
        const data = new FormData(e.currentTarget)

        if (update && osc) {
            setLoad(true)
            data.append('_method', 'PATCH')
            if (isPublic){
                await api.post(`/client/me/struct`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }else {
                await api.post(`admin/osc/${osc.id}/struct`, data).then(res => {
                    setNewData(res.data);
                    setIsSuccess(true)
                }).catch(console.log)
            }
            setLoad(false)
            return
        }
        if(!osc) return
        await api.post(`/osc/${osc.id}/struct`, data).then(res => {
            setStep(5)
        }).catch(console.log)
        setLoad(false)

    }, [api, setStep, osc,update, setLoad, isPublic ])

    const data = useMemo((): Osc | undefined => {

        let data: Osc | undefined = undefined

        if (osc) data = osc

        if (oldData) data = oldData

        if (newData) data = newData

        return data

    }, [oldData, osc, newData ])

    useEffect(()=>{
        if(osc?.performace) setStep(5);
    },[osc,setStep])

    return(
        <>
        {update && <div className='font-semibold text-xl mb-2 mt-3'>Estrutura organizacional</div>}
        {isSuccess && <SuccessAlert message='Estrutura organizacional atualizado' closeAlert={()=>setIsSuccess(false)} />}
        <form onSubmit={handleSubmit} className={`grid gap-x-6 gap-y-2 grid-cols-1 md:grid-cols-1 ${data && 'border-l-4 border-green-600 pl-4 pr-4 rounded-lg'}`}>

            <GridFields label="Quantos funcionários remunerados a instituição mantêm?">
                <OscInput name={"structure[0][employees]"} necessary require defaultValue={data?.structure?.employees ? data.structure.employees : "0"}/>
            </GridFields>

            <GridFields label="Quantos voluntários (regulares ou pontuais) a organização mantêm atualmente?">
                <OscInput name={"structure[0][voluntaries]"} necessary require defaultValue={data?.structure?.voluntaries ? data.structure.voluntaries : "0"}/>
            </GridFields>

            <GridFields label="Em média anual, qual o orçamento da sua instituição?">
                <MoneyInput
                name={"structure[0][annual_budget]"}
                necessary defaultValue={data?.structure?.annual_budget ? data.structure.annual_budget : ""}/>
            </GridFields>

            <OscTrueFalseInput
                label="Possui sede própria?"
                name='structure[0][headquarters]'
                isCheck={data?.structure?.headquarters ? true : false}
            />
            <OscTrueFalseInput
                label="Possui convênios vigentes com o poder público?"
                needDescription
                descriptionText={data?.structure?.public_powers}
                isCheck={data?.structure?.public_powers ? true : false}
                name={"structure[0][public_powers]"}
            />
            <OscTrueFalseInput
                label="Possui projetos aprovados em algum fundo/lei de incentivo?"
                needDescription
                descriptionText={data?.structure?.approved_projects}
                isCheck={data?.structure?.approved_projects ? true : false}
                name={"structure[0][approved_projects]"}
            />
               <div className='flex justify-between mb-3 mt-3'>
                   {load && <SpinnerLoad />}
                   {!load && <>
                    <div>
                         {!update && <button onClick={()=>setStep(3)} className='border border-gray-500 bg-white py-1 px-2 rounded-md'>Anterior</button>}
                    </div>

                    <div>
                        <SubmitButton value={update ? "Atualizar " : "Proximo"} />
                    </div>
                    </>}
                </div>


        </form>
        </>
    )
}

interface Props {
    update?: boolean
    oldData?: Osc
    isPublic?:boolean
}
